export default {
    API_ENDPOINT: 'https://calm-coast-19093.herokuapp.com/api',
    TOKEN_KEY: 'mood-garden-client-auth-token',
}